import * as CONFIGS from '@/statics/configs.js';

const NODE2 = {
    NAME: 'RailMountServer',
    INPUT1: {
        NAME: 'NODE2_INPUT1_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x8080,
    },
    INPUT2: {
        NAME: 'NODE2_INPUT2_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x8081,
    },
    INPUT3: {
        NAME: 'NODE2_INPUT3_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x8082,
    },
    INPUT4: {
        NAME: 'NODE2_INPUT4_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x8083,
    },
    INPUT5: {
        NAME: 'NODE2_INPUT5_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x8084,
    },
    INPUT6: {
        NAME: 'NODE2_INPUT6_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x8085,
    },
    INPUT7: {
        NAME: 'NODE2_INPUT7_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x8086,
    },
    INPUT8: {
        NAME: 'NODE2_INPUT8_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x8087,
    },
    INPUT9: {
        NAME: 'NODE2_INPUT9_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x8088,
    },
    INPUT10: {
        NAME: 'NODE2_INPUT10_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x8089,
    },
    INPUT11: {
        NAME: 'NODE2_INPUT11_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x808A,
    },
    INPUT12: {
        NAME: 'NODE2_INPUT12_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x808B,
    },
    INPUT13: {
        NAME: 'NODE2_INPUT13_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x808C,
    },
    INPUT14: {
        NAME: 'NODE2_INPUT14_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x808D,
    },
    INPUT15: {
        NAME: 'NODE2_INPUT15_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x808E,
    },
    INPUT16: {
        NAME: 'NODE2_INPUT16_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x808F,
    },
    INPUT17: {
        NAME: 'NODE2_INPUT17_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x8090,
    },
    INPUT18: {
        NAME: 'NODE2_INPUT18_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x8091,
    },
    INPUT19: {
        NAME: 'NODE2_INPUT19_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x8092,
    },
    INPUT20: {
        NAME: 'NODE2_INPUT20_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x8093,
    },
    INPUT21: {
        NAME: 'NODE2_INPUT21_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x8094,
    },
    INPUT22: {
        NAME: 'NODE2_INPUT22_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x8095,
    },
    INPUT23: {
        NAME: 'NODE2_INPUT23_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x8096,
    },
    INPUT24: {
        NAME: 'NODE2_INPUT24_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x8097,
    },
    INPUT25: {
        NAME: 'NODE2_INPUT25_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x8098,
    },
    INPUT26: {
        NAME: 'NODE2_INPUT26_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x8099,
    },
    INPUT27: {
        NAME: 'NODE2_INPUT27_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x809A,
    },
    INPUT28: {
        NAME: 'NODE2_INPUT28_NAME',
        TYPE: 'zeroContact',
        ICON: 'switch',
        PARAMETER_ID: 0x809B,
    },

    
    OUTPUT1: {
        NAME: 'NODE2_OUTPUT1_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE000,
    },
    OUTPUT2: {
        NAME: 'NODE2_OUTPUT2_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE001,
    },
    OUTPUT3: {
        NAME: 'NODE2_OUTPUT3_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE002,
    },
    OUTPUT4: {
        NAME: 'NODE2_OUTPUT4_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE003,
    },
    OUTPUT5: {
        NAME: 'NODE2_OUTPUT5_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE004,
    },
    OUTPUT6: {
        NAME: 'NODE2_OUTPUT6_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE005,
    },
    OUTPUT7: {
        NAME: 'NODE2_OUTPUT7_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE006,
    },
    OUTPUT8: {
        NAME: 'NODE2_OUTPUT8_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE007,
    },
    OUTPUT9: {
        NAME: 'NODE2_OUTPUT9_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE008,
    },
    OUTPUT10: {
        NAME: 'NODE2_OUTPUT10_NAME',
        TYPE: 'RelaySSR2A', 
        ICON: 'lamp',
        PARAMETER_ID: 0xE009,
    },
    OUTPUT11: {
        NAME: 'NODE2_OUTPUT11_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE00A,
    },
    OUTPUT12: {
        NAME: 'NODE2_OUTPUT12_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE00B,
    },
    OUTPUT13: {
        NAME: 'NODE2_OUTPUT13_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE00C,
    },
    OUTPUT14: {
        NAME: 'NODE2_OUTPUT14_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE00D,
    },
    OUTPUT15: {
        NAME: 'NODE2_OUTPUT15_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE00E,
    },
    OUTPUT16: {
        NAME: 'NODE2_OUTPUT16_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE00F,
    },
    OUTPUT17: {
        NAME: 'NODE2_OUTPUT17_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE010,
    },
    OUTPUT18: {
        NAME: 'NODE2_OUTPUT18_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE011,
    },
    OUTPUT19: {
        NAME: 'NODE2_OUTPUT19_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE012,
    },
    OUTPUT20: {
        NAME: 'NODE2_OUTPUT20_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE013,
    },
    OUTPUT21: {
        NAME: 'NODE2_OUTPUT21_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE014,
    },
    OUTPUT22: {
        NAME: 'NODE2_OUTPUT22_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE015,
    },
    OUTPUT23: {
        NAME: 'NODE2_OUTPUT23_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE016,
    },
    OUTPUT24: {
        NAME: 'NODE2_OUTPUT24_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE017,
    },
    OUTPUT25: {
        NAME: 'NODE2_OUTPUT25_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE018,
    },
    OUTPUT26: {
        NAME: 'NODE2_OUTPUT26_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE019,
    },
    OUTPUT27: {
        NAME: 'NODE2_OUTPUT27_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE01A,
    },
    OUTPUT28: {
        NAME: 'NODE2_OUTPUT28_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE01B,
    },
    OUTPUT29: {
        NAME: 'NODE2_OUTPUT29_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE01C,
    },
    OUTPUT30: {
        NAME: 'NODE2_OUTPUT30_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE01D,
    },
    OUTPUT31: {
        NAME: 'NODE2_OUTPUT31_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE01E,
    },
    OUTPUT32: {
        NAME: 'NODE2_OUTPUT32_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE01F,
    },
    OUTPUT33: {
        NAME: 'NODE2_OUTPUT33_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE020,
    },
    OUTPUT34: {
        NAME: 'NODE2_OUTPUT34_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE021,
    },
    OUTPUT35: {
        NAME: 'NODE2_OUTPUT35_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE022,
    },
    OUTPUT36: {
        NAME: 'NODE2_OUTPUT36_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE023,
    },
    OUTPUT37: {
        NAME: 'NODE2_OUTPUT37_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE024,
    },
    OUTPUT38: {
        NAME: 'NODE2_OUTPUT38_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE025,
    },
    OUTPUT39: {
        NAME: 'NODE2_OUTPUT39_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE026,
    },
    OUTPUT40: {
        NAME: 'NODE2_OUTPUT40_NAME',
        TYPE: 'RelaySSR2A',
        ICON: 'lamp',
        PARAMETER_ID: 0xE027,
    },
}

export default NODE2;